import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IndicatorsService } from '../../../../services/indicators/indicators.service';
import { isUndefined } from 'util';
import { Point } from '../../../../models/pointWidget.model';


@Component({
  selector: 'app-point-loyalty-widget',
  templateUrl: './point-loyalty-widget.component.html',
  styleUrls: ['./point-loyalty-widget.component.css']
})
export class PointLoyaltyWidgetComponent implements OnInit, OnChanges {

  @Input() data: any;

  pointData: Array<Point>;


  constructor(private indicatorService: IndicatorsService) {

  }

  ngOnInit() {
    if (!isUndefined(this.data)) {
      this.indicatorService.getWidgetsPoint(this.data).subscribe((res) => {
        this.pointData = res;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!isUndefined(changes['data'].currentValue)) {
      this.ngOnInit();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/point-loyalty-widget/point-loyalty-widget.component.ts